export default {"SNOWPACK_PUBLIC_API_HOST":"//checkoutapi.ticketbutler.io/api","MODE":"production","NODE_ENV":"production","SSR":false};